<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="SUB-GRUPOS DE ESTOQUE" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/stock1.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/subgrupos-estoque']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label style="font-weight: bold; color: #757575">
            {{login.orgao.codigo}} {{login.orgao.nome}}
          </label>
        </div>
      </div>
      <hr class="mt-1 mb-4" />

      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" role="tablist" style="font-size: 13px;">
              <li class="nav-item">
                <a class="nav-link active" id="principal-tab" data-toggle="tab" href="#principal" role="tab"
                  aria-controls="principal" aria-selected="true">Dados do Sub-Grupo</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="material-tab" data-toggle="tab" href="#material" role="tab"
                  aria-controls="material" aria-selected="true">Materiais vinculados a este sub-grupo</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
                <div class="form-row pt-3">
                  <div class="col-1 d-none d-lg-block d-xl-block col-md-auto"
                    style="width: 45px; height: 256px; border-right: 1px solid #ebebeb; margin-right: 10px">
                    <img src="assets/img/contabil/building.png" alt="liquida">
                  </div>
                  <div class="col-md-7 col-lg-7 col-xl-7">
                    <div class="form-row">
                      <div class="form-group col-md-2">
                        <label for="codigo">Código</label>
                        <input readonly id="codigo" value="{{entidade.codigo}}" type="text"
                          class="form-control-plaintext">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="nome">Nome</label>
                        <input readonly id="nome" value="{{entidade.nome}}" type="text"
                          class="form-control-plaintext font-weight-bold">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="grupo">Grupo</label>
                        <input *ngIf="entidade.grupo" readonly id="grupo"
                          value="{{entidade.grupo.codigo}} {{entidade.grupo.nome}}" type="text"
                          class="form-control-plaintext">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4 col-xl-4">
                    <span *ngIf="entidade.bec" class="badge badge-primary">Bec</span>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="material" role="tabpanel" aria-labelledby="material-tab">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <table class="table table-eddy">
                      <thead>
                        <tr>
                          <th scope="col">Código</th>
                          <th scope="col">Nome</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of entidade.materiais">
                          <td style="width: 20%">{{item.codigo}}</td>
                          <td style="width: 80%;">{{item.nome}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
    </form>
  </div>
</div>